import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import noop from 'lodash/noop'
import head from 'lodash/head'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import isNumber from 'lodash/isNumber'
import compact from 'lodash/compact'
import debounce from 'lodash/debounce'
import isNil from 'lodash/isNil'
import uniqBy from 'lodash/uniqBy'
import get from 'lodash/get'
import IconCaretDown from '@vtex/styleguide/lib/icon/CaretDown'
import IconCaretUp from '@vtex/styleguide/lib/icon/CaretUp'
import { Skeleton, csx } from '@vtex/admin-ui'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import {
  listenLogisticsInfoChanges,
  unlistenLogisticsInfoChanges,
} from '@/checkout-instore-legacy/cache/utils'
import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import SKUSelector from '../../../Commons/SKUSelector'
import { productPriceLoaderStyles } from '@/checkout-instore-legacy/product/ProductPage/loaderStyles'
import {
  isSkuAvailable,
  getProductPurchaseConditionPrice,
} from '@/checkout-instore-legacy/utils/CatalogUtils'
import {
  getDefaultSeller,
  getDefaultSellerId,
} from '@/checkout-instore-legacy/seller/utils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import {
  changeImageUrlSize,
  cleanImageUrl,
} from '@/checkout-instore-legacy/utils/ProductUtils'
import BuyComponent from '@/checkout-instore-legacy/components/Commons/BuyComponent'
import { isProductOpen } from '../../utils/index'
import { getSimulationLogisticsInfo } from '@/checkout-instore-legacy/cart/simulation/utils'
import { getLogisticsInfo } from '@/checkout-instore-legacy/cache/CatalogCache'
import { ProductSellerName } from '../../../Commons/ProductSummary/ProductName/ProductSellerName'
import {
  getProductSkuData,
  getSkuSelectorProps,
  getSkuStock,
  removeProductNameFromSku,
} from '@/checkout-instore-legacy/product/utils'
import { ProductPrice } from '@/checkout-instore-legacy/components/ProductPrice/ProductPrice'

class SearchResult extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSelectorOpen: false,
      allVariationsSelected: false,
      selectedVariations: {},
      availableVariatios: {},
      selectedSku: null,
      skuProps: { key: 0 },
      stockAlreadyCalled: false,
      stockQuantity: {
        inStoreQuantity: 0,
        otherQuantity: 0,
      },
      logisticsInfoCache: {},
    }
  }

  handleToggleSelector = (event) => {
    event && event.stopPropagation()
    if (this.props.searchSimulationLoading) {
      return
    }

    this.props.handleToggleItem()
  }

  verifyAndOpenProduct = () => {
    const {
      isSelectorOpen,
      isUniqueItem,
      term,
      searchSimulationLoading,
    } = this.props
    const shouldOpenProduct = isProductOpen({
      term,
      isSelectorOpen,
      isUniqueItem,
      loading: searchSimulationLoading,
    })
    if (shouldOpenProduct) {
      this.handleToggleSelector()
    }
  }

  handleVariationSelectionChange = ({
    sku,
    allVariationsSelected,
    selectedVariations,
    price,
  }) => {
    const shouldUpdateStateAndStock = !Object.values(selectedVariations).some(
      isNil
    )
    this.setState({
      selectedSku: sku,
      allVariationsSelected,
      selectedVariations,
      placeHolderPrice: price,
    })
    if (shouldUpdateStateAndStock) {
      this.props.updateStock(sku.id)
    }
  }

  getSkuIsAvailable(sku, logisticsInfoCache) {
    const initialQuantity = 1
    const skuLogisticsInfo = getSimulationLogisticsInfo(
      logisticsInfoCache,
      sku.id,
      initialQuantity
    )

    let skuIsAvailableAtInitialQuantity
    if (!isEmpty(skuLogisticsInfo)) {
      skuIsAvailableAtInitialQuantity =
        sku && isSkuAvailable(sku, skuLogisticsInfo)
    } else {
      const { item } = this.props

      const originalPriceData = getProductPurchaseConditionPrice(
        item,
        sku,
        true
      )

      const priceData = {
        listPrice: originalPriceData.listPrice,
        price: originalPriceData.price,
      }
      skuIsAvailableAtInitialQuantity = sku && isNumber(priceData.price)
    }
    return skuIsAvailableAtInitialQuantity
  }

  getInitialVariations = (skus) => {
    const { item, intl, price, name: productName } = this.props
    const { variations } = item
    const availableSkus = skus.filter((sku) => sku.available)

    if (isEmpty(variations)) {
      if (availableSkus.length === 1) {
        const selectedVariations = {}
        const genericVariationLabel = intl.formatMessage({
          id: 'variationLabel',
        })
        const variationName = removeProductNameFromSku(
          item.skus[0].name,
          productName
        )
        selectedVariations[genericVariationLabel] = variationName
        this.setState({
          allVariationsSelected: true,
          selectedVariations,
          placeHolderPrice: price,
        })
      }
      return
    }

    const availableVariations = variations.map((variation) => {
      const value = uniqBy(availableSkus.map((sku) => sku[variation.label]))
      return {
        label: variation.label,
        value,
      }
    })
    return availableVariations
  }

  createSkuProps = () => {
    const { intl, item, isSelectorOpen } = this.props
    const { skuProps, logisticsInfoCache } = this.state
    let props = { variations: [], skus: [], key: skuProps.key + 1 }

    if (isEmpty(item.skus) || !isSelectorOpen) {
      this.setState({ skuProps: props, key: skuProps.key + 1 })
      return
    }

    props = {
      ...props,
      ...getSkuSelectorProps({
        product: item,
        logisticsInfoCache,
        intl,
      }),
    }

    this.setState({ skuProps: props, key: skuProps.key + 1 })

    const singleVariations = this.getInitialVariations(props.skus)
    if (!isEmpty(singleVariations)) {
      this.getAutoSelectVariations(singleVariations)
    }
    return
  }

  buildStatefromItem = () => {
    const { skus } = this.props.item

    const defaultSku =
      compact(skus).find((sku) => {
        const { sellers } = sku
        const defaultSeller = getDefaultSeller(sellers)
        return (
          defaultSeller &&
          defaultSeller.commertialOffer &&
          defaultSeller.commertialOffer.availableQuantity > 0
        )
      }) || head(skus)

    this.setState({
      selectedSku: defaultSku,
      placeHolderPrice: defaultSku.price,
    })
  }

  getAutoSelectVariations = (variations) => {
    const { price } = this.props

    const selectedVariations = {}
    const variationsSelected = []

    variations.forEach((variation) => {
      selectedVariations[variation.label] =
        variation.value.length === 1 ? variation.value[0] : null
      if (selectedVariations[variation.label] !== null) {
        variationsSelected.push(true)
      }
    })
    const allVariationsSelected =
      variationsSelected.length === variations.length

    this.setState({
      allVariationsSelected,
      selectedVariations,
      placeHolderPrice: price,
    })
  }

  componentDidMount() {
    this.verifyAndOpenProduct()
    this.buildStatefromItem()
    this.createSkuProps()

    this.updateLogisticsInfoCache()

    if (this.props.item.skus) {
      listenLogisticsInfoChanges(
        this.props.item.skus,
        this.updateLogisticsInfoCache
      )
    }
  }

  componentWillUnmount() {
    unlistenLogisticsInfoChanges(
      this.props.item.skus,
      this.updateLogisticsInfoCache
    )
  }

  updateLogisticsInfoCache = debounce(
    () => {
      const skusIds = this.props.item.skus.map((sku) => sku.id)

      getLogisticsInfo(skusIds).then((logisticsInfo) => {
        this.setState({ logisticsInfoCache: logisticsInfo })
        this.props.stopLoading()
      })
    },
    500,
    { maxWait: 1000 }
  )

  componentDidUpdate(prevProps, prevState) {
    const { item, isSelectorOpen, searchSimulationLoading } = this.props

    this.verifyAndOpenProduct()

    const searchSimulationFinishedLoading =
      prevProps.searchSimulationLoading && !searchSimulationLoading
    if (
      !isEqual(this.props.item, prevProps.item) ||
      searchSimulationFinishedLoading
    ) {
      this.buildStatefromItem()
    }

    if (!isSelectorOpen && this.state.stockAlreadyCalled) {
      this.setState({ stockAlreadyCalled: false })
    }

    const shouldUpdateStock =
      !this.state.stockAlreadyCalled &&
      item &&
      item.skus &&
      item.skus.length === 1 &&
      isSelectorOpen &&
      prevState.key !== this.state.key

    const shouldLoadStock =
      !this.props.isLoadingStock &&
      !isEmpty(this.props.stock) &&
      prevState.selectedSku &&
      this.state.selectedSku &&
      this.state.selectedSku.id !== prevState.selectedSku.id

    if (shouldUpdateStock) {
      this.setState({ stockAlreadyCalled: true })
      this.props.setLoadingStock(true)
      this.props.updateStock(this.state.selectedSku.id)
    }

    if (shouldLoadStock) {
      this.props.setLoadingStock(true)
    }

    const isLogisticsInfoCacheStateDifferent = !isEqual(
      this.state.logisticsInfoCache,
      prevState.logisticsInfoCache
    )

    const isSelectorOpenDifferent =
      this.props.isSelectorOpen !== prevProps.isSelectorOpen

    const shouldUpdateSkuProps =
      (!this.state.allVariationsSelected &&
        isLogisticsInfoCacheStateDifferent) ||
      isSelectorOpenDifferent ||
      searchSimulationFinishedLoading

    if (shouldUpdateSkuProps) {
      this.createSkuProps()
    }
  }

  handleClickMoreDetails = () => {
    const { item } = this.props
    const { logisticsInfoCache } = this.state
    const { skus } = item

    const allVariationsSelected =
      this.state.allVariationsSelected || (skus && skus.length === 1)
    const { selectedSku } = this.state
    const firstSku = item.skus.findIndex((sku) =>
      this.getSkuIsAvailable(sku, logisticsInfoCache)
    )
    const lastSku = item.skus
      .reverse()
      .findIndex((sku) => this.getSkuIsAvailable(sku, logisticsInfoCache))

    item.skus.reverse()

    const singleSku =
      firstSku + lastSku === item.skus.length - 1
        ? item.skus[firstSku].id
        : null

    this.props.onClickMoreDetails(
      item.id,
      allVariationsSelected ? selectedSku.id : singleSku
    )
  }

  addRecentTerm = () => {
    const { addRecentTerm, term, item } = this.props
    addRecentTerm({ term, productName: item.name })
  }

  render() {
    const {
      item,
      currencyCode,
      index,
      stock,
      isLoadingStock,
      isSelectorOpen,
      isSimulationLoading,
      searchSimulationLoading,
    } = this.props
    const { logisticsInfoCache, selectedSku, placeHolderPrice } = this.state

    if (!selectedSku) {
      return null
    }

    const {
      featureToogle: { showDiscountOnProductPage },
      sellWithoutStockInHands,
    } = getInstoreConfig()

    const { skus, name } = item

    const {
      availableQuantity,
      showSkuSelector,
      isAllVariationsSelected,
    } = getProductSkuData(
      item,
      selectedSku,
      null,
      this.state.allVariationsSelected,
      logisticsInfoCache
    )

    const skuIsAvailableAtInitialQuantity =
      isSelectorOpen && selectedSku
        ? this.getSkuIsAvailable(selectedSku, logisticsInfoCache)
        : item.skus.some((sku) =>
            this.getSkuIsAvailable(sku, logisticsInfoCache)
          )

    const originalPriceData = getProductPurchaseConditionPrice(
      item,
      selectedSku,
      isAllVariationsSelected,
      placeHolderPrice
    )

    const priceData = {
      listPrice: originalPriceData.listPriceInCents / 100,
      price: originalPriceData.priceInCents / 100,
    }

    const showStartingAt =
      priceData.price && item.skus.length > 1 && !isAllVariationsSelected

    const productPriceProps = {
      styles: productPriceLoaderStyles,
      listPriceContainerClass: 't-small c-muted-2 mb2',
      listPriceClass: 'ph2 dib strike',
      sellingPriceContainerClass: 'pv1 b c-on-base',
      sellingPriceClass: 'b b-l t-body t-heading-4-l dib',
      startingAtClass: 't-mini t-body-l dib mr2',
      interestRateClass: 'dib ph2',
      savingsContainerClass: 'c-success mt3',
      savingsClass: 'dib t-small',
      unavailableClass: 't-heading-5-s dib ph2',
      showLabels: false,
      showStartingAt: showStartingAt,
      showSavings: showDiscountOnProductPage,
      loaderClass: '',
      showListPrice: isAllVariationsSelected,
      listPrice: priceData.listPrice,
      /**  The sku returned from the sku selector is preferentially available */
      unavailable: !skuIsAvailableAtInitialQuantity,
      sellingPrice: priceData.price,
      currency: currencyCode,
    }

    const productImage = changeImageUrlSize(
      cleanImageUrl(head(selectedSku.images)),
      320,
      320
    )

    const skuStock = getSkuStock(
      selectedSku,
      stock,
      availableQuantity,
      isLoadingStock
    )

    const selectedSkuSeller = getDefaultSeller(get(selectedSku, 'sellers', []))
    const selectedSkuSellerId = get(selectedSkuSeller, 'id')
    const isDefaultSeller = selectedSkuSellerId === getDefaultSellerId()
    const skuSellerInfo = !isDefaultSeller ? (
      <div
        className="pt2 pb6 db mb2 mb0-ns inline-flex-ns items-center"
        data-testid="seller-info"
      >
        <ProductSellerName sellerId={selectedSkuSellerId} />
      </div>
    ) : null

    const getImgStyle = () => {
      return {
        backgroundImage: `url(${productImage})`,
        minWidth: isSelectorOpen ? '10rem' : '4rem',
      }
    }

    const SearchSkeleton = () => {
      return (
        <div
          className={csx({
            display: 'block',
            width: '11.563rem',
            height: '1.5rem',
          })}
        >
          <Skeleton />
        </div>
      )
    }

    const bgClass = 'bg-base'
    return (
      <li
        className={`flex-l flex-row-l pa5 ${bgClass} b--muted-4 bt-0 bl-0 br-0 bb relative c-on-base ${
          isSelectorOpen ? '' : 'pointer'
        }`}
        id={`productlistitem-${index}-search-result`}
        onClick={isSelectorOpen ? noop : this.handleToggleSelector}
      >
        <div className={`flex flex-row ${bgClass} wrap`}>
          <div
            className={`w3 h3 cover mr5 ${
              isSelectorOpen ? 'w20-l h20-l w10-ml h10-ml bg-center-s' : ''
            }`}
            style={getImgStyle()}
          />
          <div
            className={`flex justify-between flex-column ${
              isSelectorOpen ? ' dn-l' : ''
            }`}
          >
            <span
              className="t-small t-heading-5-l"
              id={`productlistitem-${index}-name`}
            >
              {name}
            </span>
            {skuSellerInfo}

            <span id={`productlistitem-${index}-price`}>
              {searchSimulationLoading ? (
                <SearchSkeleton />
              ) : (
                <ProductPrice {...productPriceProps} />
              )}
            </span>
          </div>
          <div className={`w3 ${isSelectorOpen ? 'dn-l' : ''}`} />
          <div
            id={`productlistitem-${index}-toggle-selector`}
            className=" absolute top-0 right-0 pa5 pointer"
            onClick={this.handleToggleSelector}
          >
            {searchSimulationLoading ? (
              <IconCaretUp
                size={14}
                color={getClassStyle('c-muted-1', 'color')}
              />
            ) : (
              <IconCaretDown
                size={14}
                color={getClassStyle('c-muted-1', 'color')}
              />
            )}
          </div>
        </div>
        {isSelectorOpen && (
          <div className="flex justify-between flex-row w-100">
            <div
              data-testid={`productlistitem-${index}-search-result-open-body`}
              className="mv5 mv0-l w-100"
            >
              <div className="dn db-l">
                <div
                  className={`t-heading-5-l ${isDefaultSeller ? 'mb3' : ''}`}
                >
                  {name}
                </div>
                {skuSellerInfo}
                <span
                  className={`t-small b t-heading-3-l${
                    isNil(priceData.price)
                      ? ' h22 w4 w5-ns overflow-hidden'
                      : ''
                  }`}
                  id={`productlistitem-${index}-price`}
                >
                  {searchSimulationLoading ? (
                    <SearchSkeleton />
                  ) : (
                    <ProductPrice {...productPriceProps} />
                  )}
                </span>
              </div>
              {skus && showSkuSelector && !isEmpty(logisticsInfoCache) && (
                <SKUSelector
                  {...this.state.skuProps}
                  selectedVariations={this.state.selectedVariations}
                  askToSelectVariations={false}
                  onChange={this.handleVariationSelectionChange}
                  designTokens={{
                    skuSelectorContainer: 'flex flex-column mb5',
                  }}
                />
              )}
              <div className="w-75-l">
                <BuyComponent
                  sku={isAllVariationsSelected ? selectedSku : null}
                  logisticsInfoCache={logisticsInfoCache}
                  isSimulationLoading={isSimulationLoading}
                  skuIsAvailableAtInitialQuantity={
                    skuIsAvailableAtInitialQuantity
                  }
                  availableQuantity={availableQuantity}
                  beforeAddToCart={this.addRecentTerm}
                  onClickMoreDetails={this.handleClickMoreDetails}
                  stock={skuStock}
                  isLoadingStock={isLoadingStock && availableQuantity > 0}
                  setLoadingStock={this.props.setLoadingStock}
                  sellWithoutStockInHands={sellWithoutStockInHands}
                />
              </div>
            </div>
            <div className="w2" />
          </div>
        )}
      </li>
    )
  }
}

SearchResult.propTypes = {
  index: PropTypes.number.isRequired,
  addRecentTerm: PropTypes.func,
  term: PropTypes.string,
  isSelectorOpen: PropTypes.bool.isRequired,
  handleToggleItem: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  currencyCode: PropTypes.string.isRequired,
  searchSimulationLoading: PropTypes.bool,
  intl: intlShape,
  onClickMoreDetails: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  updateStock: PropTypes.func.isRequired,
  setLoadingStock: PropTypes.func.isRequired,
  stock: PropTypes.object,
  isLoadingStock: PropTypes.bool,
  isUniqueItem: PropTypes.bool,
  isSimulationLoading: PropTypes.bool,
  stopLoading: PropTypes.func.isRequired,
}

export default withRouter(injectIntl(SearchResult))
